<template>
    <div>
        <updateoi :isDetail="true"></updateoi>
    </div>
</template>

<script>
import updateoi from "@/pages/security/vertify/updateoi"
export default {
    name:"queryoi",
    components: {
        updateoi
    },
    data() {
        return {

        };
    },
    computed: {},
    methods: {},
    created() {},
    mounted() {},
    beforeCreate() {},
    beforeMount() {},
    beforeUpdate() {},
    updated() {},
    beforeDestroy() {},
    destroyed() {},
    activated() {},
    watch: {},
}
</script>
<style scoped>
</style>


// WEBPACK FOOTER //
// src/pages/security/vertify/queryoi.vue